/**
 * Anzeige-Labels für den Gesamtstatus-Badge.
 *
 * Die fachlichen Statuswerte kommen unverändert aus dem Backend (core/enums.py) und stehen so
 * auch in den Domänen-Dropdowns. Für den Badge in Projektübersicht und Projektrahmen sind sie
 * teilweise zu lang - dort wird eine gekürzte Schreibweise gezeigt, der volle Wert wandert in
 * einen Tooltip. Nicht aufgeführte Werte sind bereits kurz genug und bleiben unverändert.
 */

const KURZ_LABELS: Record<string, string> = {
  "Flächensicherung läuft": "Fläche läuft",
  "Flächen gesichert": "Fläche gesichert",
  "Genehmigungsverfahren läuft": "Genehmigung läuft",
};

export interface GesamtstatusLabel {
  /** Text für den Badge (gekürzt, wo nötig) */
  label: string;
  /** Voller Statuswert - nur gesetzt, wenn gekürzt wurde (sonst kein Tooltip nötig) */
  tooltip: string | null;
}

export function getGesamtstatusLabel(gesamtstatus: string): GesamtstatusLabel {
  const kurz = KURZ_LABELS[gesamtstatus];
  return kurz
    ? { label: kurz, tooltip: gesamtstatus }
    : { label: gesamtstatus, tooltip: null };
}
